import { FC } from "react";
import { BookingProduct, Product } from "../../types";
import { _, parseNum } from "../../utils/helpers";
import { AddButton } from "./AddButton";
import { Icon } from "../Icon";
import { useApp } from "../../context/useApp";
import { DEFAULT_DIALOG_HANDLE, PRODUCTS_WICH_QTY_IS_FIXED_TO_PAX, SURCHARGE_NAME } from "../../utils/symbols";
import { Switch } from "./Switch";

interface ProductsQtySelectorProps {
    products: Product[]
    autoSelectFirstButton?: boolean
    onProductQtyChange: (product:Product,  newQty: number) => void
}

export const ProductsQtySelector: FC<ProductsQtySelectorProps> = ({products, onProductQtyChange, autoSelectFirstButton}) => {

    const {
        state: { booking, dialogHandles, priceRules, tableMapHandle }
    } = useApp()

    const dialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE

    const openDialog = (product: Product) => {

        dialogHandle.openDialog({
            className: 'product w-100 h-100 df aic jcc',
            dialog: 'product', 
            product: product
        })
    }

    return (
        <ul className="w-100" role="region" aria-label={_('4co_compl__')}>
            { products.map((product, index) => {

                if (product.name === SURCHARGE_NAME) return null

                let qty = booking.getProductQty(product.id)

                const id = `product-${product.id}`
                const displaySwitch = PRODUCTS_WICH_QTY_IS_FIXED_TO_PAX.includes(product.id)

                const parsedPrice = `${parseNum('EUR', product.price)}${displaySwitch ? `/${_('0ge_ticke__')}` : ''}`
                
                return (
                    <li 
                        key={index} 
                        id={id}
                        className={`df aic jcsb w-100 mt-8`}
                        tabIndex={0}
                        role="group"
                        aria-label={`${product.name}, ${parsedPrice}. ${qty} ${_('0ar_selec__')}. ${product.description}`}
                    >
                        <div className="df aic" aria-hidden>
                            <p className="text s18-500 mr-3">{product.name}</p>
                            <button 
                                aria-hidden
                                tabIndex={-1}
                                onClick={() => openDialog(product)}
                                className="button b-0 p-0 mr-3"
                            >
                                <Icon icon="info"/>
                            </button>
                        </div>
                        <div className="df aic jcfe">

                            <p className="text s18-600 right mr-5" aria-hidden>
                                {   product.discounts.length > 0 &&
                                    <span className="text softer strikethrough mr-4 s16-500">
                                    {parseNum('EUR', product.originalPrice)}       
                                    </span>
                                }
                                {parsedPrice}
                            </p>

                            { displaySwitch ?
                                <Switch 
                                    value={qty} 
                                    onChange={(checked) => onProductQtyChange(product, checked ? 1 : 0)}
                                    // autoFocus={autoFocus}
                                />
                                :
                                <AddButton 
                                    alwaysDisplayCounter
                                    min={0}
                                    qty={qty}
                                    max={100}
                                    onAddButtonClick={(newQty) => onProductQtyChange(product, newQty)}
                                    // autoFocus={autoFocus}
                                />
                            }
                        </div>
                    </li>
                )
            })}
            </ul>
    )
}